var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("Note:")]),_vm._v(" This is only necessary if the event was previously marked as compliant by other logic.\n")])}]

export { render, staticRenderFns }